import { translate } from 'components/Translation';
import React from 'react';
import CardBody from 'components/Card/CardBody';
import Card from 'components/Card/Card';
import { BodyMBold } from 'components/Typography/Typography';
import Button from 'components/CustomButtons/Button';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/refreshStatusStyle';
import { makeStyles } from '@material-ui/core';
import Cached from '@material-ui/icons/Cached';
import invalidateCache from 'utils/api/invalidateCache';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IRefreshStatusesCard {
	fetchData: (showNotification?: boolean) => void;
}

const RefreshStatusesCard = ({ fetchData }: IRefreshStatusesCard) => {
	const classes = useStyles();

	const updateStatus = () => {
		invalidateCache(['getCustomerProducts', 'getUsage', 'getOrderStatus'], true);
		fetchData(true);
	};

	return (
		<Card>
			<CardBody className={classes.statusWrapper}>
				<BodyMBold disableMargin color="enterprise">
					{translate('refresh.statuses.text')}
				</BodyMBold>
				<Button color="primary-light" className={classes.refreshButton} onClick={updateStatus}>
					<>
						<Cached />
						{translate('refresh.statuses.button')}
					</>
				</Button>
			</CardBody>
		</Card>
	);
};

export default RefreshStatusesCard;
